<!-- #region Page header -->
<div class="page-body">
    <div id="table-admin">
        <div class="card">
            <div class="row">
                <div class="col-sm-12">
                    <!-- #region Basic Form Inputs card -->
                    <div class="card">
                        <div class="card-header">
                            <h5>Configuración de Factores</h5>
                        </div>
                    </div>
                    <!-- #endregion Basic Form Inputs card -->
                    <div class="card-block">
                        <!-- #region Form Search type person-->
                        <form>
                            <div class="row">
                                <div class="col-xs-12 col-md-12">
                                    <div class="form-group">
                                        <label for="exampleSelect1">Factores</label>
                                        <select class="form-control" name="selector"
                                            (change)="elegirFactorCombo($event.target.value)"
                                            [(ngModel)]="factores.Tabla">
                                            <option value="">Selecciona una Opción</option>
                                            <option value="{{ factor.factor }}"
                                                *ngFor="let factor of factoresResultados">
                                                {{ factor.factor }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <!-- #endregion Form Search type person-->
                    </div>
                </div>
            </div>
        </div>
        <div class="card" *ngIf="showBuscar">
            <div class="card-header">
                <h5 class="card-header-text">
                    Resultados
                </h5>
            </div>

            <div class="card-block">

                <div class="input-container">
                    <input type="mail" required="" [(ngModel)]="factores.Buscar" (input)="buscarElegirFactores()" />
                    <label>Buscar <i class="icofont icofont-ui-search"></i></label>
                </div>

                <div class="table-border-style table-pad-10 table-responsive">
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Factor</th>
                                <th>Riesgo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let factores of factoresPorRiesgoResultados">
                                <th scope="row">{{ factores.factor }}</th>
                                <td *ngIf="!esEBR">
                                    <select class="form-control" id="exampleSelect1" name="RiesgoId"
                                        [(ngModel)]="factores.riesgoId"
                                        (change)="seleccionarCambioRiesgoFactor(factores.id, $event.target.value)">
                                        <option value="-1">Selecciona una Opción</option>
                                        <option value="{{riesgo.riesgoId}}" *ngFor="let riesgo of riesgos">
                                            {{riesgo.riesgo}}</option>
                                    </select>
                                </td>
                                <td *ngIf="esEBR">
                                    <select class="form-control" id="exampleSelect1" name="RiesgoIdEBR"
                                        [(ngModel)]="factores.riesgoEbrId"
                                        (change)="seleccionarCambioRiesgoFactor(factores.id, $event.target.value)">
                                        <option value="-1">Selecciona una Opción</option>
                                        <option value="{{riesgo.riesgoId}}" *ngFor="let riesgo of riesgos">
                                            {{riesgo.riesgo}}</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row table-pad-10 paginator-container">

                <div class="col">
                    Página {{ factores.Pagina }} de {{numPage}}<br /> Total {{ total }}
                </div>

                <div class="col" *ngIf="total > 15">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-end">
                            <li class="page-item ">
                                <button class="page-link btn " (click)="paginador(false)" tabindex="-1"
                                    [disabled]="factores.Pagina <= 1">
                                    Regresar
                                </button>
                            </li>
                            <li class="page-item">
                                <button class="page-link btn" (click)="paginador(true)"
                                    [disabled]="total < 15 || factores.Pagina === numPage">
                                    Siguiente
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div class="row table-pad-10 paginator-container">
                <div class="col">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-end">
                            <li class="page-item">
                                <button type="submit" class="btn btn-info" (click)="guardarCambiosFactorEBR()">Guardar
                                    Cambios</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

        </div>
    </div>
</div>
<!-- #endregion Page header end -->